import type { BundleAdditionalDetails } from '../types/models';
import type { BundleCardConfig, BundleCardOverride, BundleCardType } from '../types/bundleTypes';

const cardTypeDefaults: Record<BundleCardType, Omit<BundleCardOverride, 'sku'>> = {
  standard: {},
  gold: {
    badge: { label: 'Vault Deal', variant: 'deal' },
    cardTheme: 'gold',
  },
  limited: {
    badge: { label: 'Limited Stock', variant: 'limited-stock' },
  },
  mystery: {
    badge: { label: 'Mystery', variant: 'mystery' },
  },
  locked: {
    badge: { label: 'Locked', variant: 'locked' },
  },
};

export const resolveBundleCards = (
  additionalBundleDetails?: BundleAdditionalDetails,
): BundleCardConfig[] =>
  (additionalBundleDetails?.cards ?? []).flatMap((group) =>
    group.skus.map((sku) => ({
      ...cardTypeDefaults[group.type],
      ...additionalBundleDetails?.customCards?.find((card) => card.sku === sku),
      sku,
      cardType: group.type,
    })),
  );

export const findBundleRiddle = (
  additionalBundleDetails: BundleAdditionalDetails | undefined,
  sku: string,
) => additionalBundleDetails?.riddles?.find((riddle) => riddle.sku === sku);
